import { ParseQuery } from './parse-query';
import { Banner } from './../data';

export class BannerQuery extends ParseQuery<Banner> {
  constructor() {
    super(Banner);
  }
}